import React, { useEffect, useState } from "react";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Invoice from "../../components/PurchaseOrder";
import { postSubmitForm } from "../../helpers/forms_helper";
import showNotification from "../../helpers/show_notification";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import FPPurchaseOrder from "../../components/FPPurchaseOrder";

const PurchaseOrder = (props) => {
  const [poData, setPOData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [poType, setPOType] = useState(null);

  const API_BASE = process.env.REACT_APP_BASEURL;

  const fetchData = async (endpoint, data) => {
    const response = await postSubmitForm(API_BASE + endpoint, data);
    if (response && response.status === 1) {
      setPOData(response.data);
    } else {
      showNotification(response.message || "Error fetching data", "Error");
    }
  };

  const loadPO = async (params) => {
    const { type, id } = params;
    setPOType(type);

    switch (type) {
      case "equipment":
        await fetchData("equipmentpurchaseorders/get_by_id", { id });
        break;
      case "branch":
        await fetchData("branchporequests/get_by_id", { id });
        break;
      case "finishedProduct":
        await fetchData("productpurchaseorders/get_by_id", { id });
        break;
      case "default":
      default:
        await fetchData("purchaseorders/get_by_id", { id });
        break;
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      const urlParams = new URLSearchParams(window.location.search);
      const poId = urlParams.get("po_id");
      const isES = urlParams.get("es");
      const FPpoId = urlParams.get("fp_po_id");

      if (FPpoId) {
        await loadPO({ type: "finishedProduct", id: FPpoId });
      } else if (isES === "true" && poId) {
        await loadPO({ type: "equipment", id: poId });
      } else if (poId) {
        await loadPO({ type: "default", id: poId });
      }
      setIsLoading(false);
    };

    loadData();
  }, []);

  const renderStatusCard = (iconClass, title, message, colorClass) => (
    <div className="page-content">
      <Container fluid>
        <Row className="justify-content-center">
          <Col xl={4} lg={6} md={8} className="text-center">
            <Card className="shadow-sm border-0">
              <CardBody className="p-4">
                <div className="avatar-lg mx-auto">
                  <div className={`avatar-title bg-soft-${colorClass} rounded-circle`}>
                    <i className={`mdi ${iconClass} font-size-24 text-${colorClass}`}></i>
                  </div>
                </div>
                <div className="mt-4">
                  <h4 className={`mb-3 text-${colorClass}`}>{props.t(title)}</h4>
                  {message && <p className="text-muted">{props.t(message)}</p>}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );

  if (isLoading) {
    return renderStatusCard(
      "mdi-file-document",
      "Loading Purchase Order...",
      "Please wait while we fetch your purchase order details",
      "primary"
    );
  }

  if (!poData) {
    return renderStatusCard(
      "mdi-alert",
      "No Purchase Order Found",
      "The requested purchase order could not be found",
      "danger"
    );
  }

  if (poType === "finishedProduct") {
    return <FPPurchaseOrder purchase_order={poData[0]} />;
  }

  return <Invoice purchase_order={poData} />;
};

const mapStatetoProps = (state) => ({});

export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(PurchaseOrder))
);
